"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var memoize = require("fast-memoize");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var bidListActions = require("@caddigital/sok-reducers/lib/actions/bid/list");
var Greeting_1 = require("components/Greeting");
var avatars_1 = require("components/Avatar/avatars");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var translate_1 = require("utils/translate");
var Types = require("types");
var Tools_1 = require("./Tools");
var PieChart_1 = require("./PieChart");
require("./style.scss");
var avatar = (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9');
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        viewportSize: state.viewport.size,
        bids: state.bid.list,
        selectedLanguage: selectedLanguage
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (briefcase) {
        return dispatch(bidListActions.fetchRequest(briefcase));
    },
    clear: function () { return dispatch(bidListActions.clear()); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var getEndTime = memoize(function (bid) {
    var meta = (bid.customMeta || []).find(function (x) { return x.identifier === 'end-at-meta'; });
    return meta ? meta.value : 0;
});
var getStatus = memoize(function (bid) {
    var meta = (bid.customMeta || []).find(function (x) { return x.identifier === 'bid-status-meta'; });
    return meta ? meta.value : 'Draft';
});
var getBids = function (type, props) {
    var now = Date.now();
    var filtered = props.bids.list
        .sort(function (a, b) {
        var ea = getEndTime(a);
        var eb = getEndTime(b);
        return ea - eb;
    })
        .filter(function (x) {
        if (getStatus(x) === 'Draft') {
            return false;
        }
        var ends = getEndTime(x);
        if (type === 'open') {
            return ends > now;
        }
        return ends <= now;
    });
    if (type === 'open')
        props.setOpenBids(filtered);
    if (type === 'closed')
        props.setClosedBids(filtered);
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('openBids', 'setOpenBids', []), (0, recompose_1.withState)('closedBids', 'setClosedBids', []), (0, recompose_1.withState)('openSearchString', 'setOpenSearchString', ''), (0, recompose_1.withState)('closedSearchString', 'setClosedSearchString', ''), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetch(this.props.currentBriefcase);
        getBids('open', this.props);
        getBids('closed', this.props);
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.bids.list !== prevProps.bids.list ||
            this.props.openSearchString !== prevProps.openSearchString) {
            getBids('open', this.props);
        }
        if (this.props.bids.list !== prevProps.bids.list ||
            this.props.closedSearchString !== prevProps.closedSearchString) {
            getBids('closed', this.props);
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var HeaderButtons = function (props) { return (React.createElement("div", { className: 'header-buttons' },
    React.createElement(sok_ui_1.Button, { color: 'green', size: 'large', url: "/".concat(props.selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bid") }, (0, translation_1.getLocalization)("briefcase/dashboard/createNewBid")),
    React.createElement(sok_ui_1.Button, { size: 'large', color: 'blue', className: '' /* 'all-bids-button' */, url: "/".concat(props.selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bids") }, (0, translation_1.getLocalization)("briefcase/dashboard/viewAllBids")))); };
var BidPanel = function (_a) {
    var type = _a.type, props = _a.props;
    var searchString = props[type + 'SearchString'].toLowerCase();
    var list = props[type + 'Bids'].filter(function (x) { return x.name.toLowerCase().includes(searchString); });
    return (React.createElement(sok_ui_1.Panel, { title: (0, translation_1.getLocalization)("briefcase/dashboard/".concat(type, "Bids")), footer: React.createElement(react_router_dom_1.Link, { className: 'show-more', to: "/".concat(props.selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bids?status=").concat((0, translation_1.getLocalization)("bidListView/column/".concat(type === 'open' ? 'published' : 'finished'))) }, (0, translation_1.getLocalization)('briefcase/dashboard/showMore')) },
        React.createElement("div", { className: "search-bids" },
            React.createElement(sok_ui_1.TextInput, { className: 'sok-text-input', value: searchString, placeholder: (0, translation_1.getLocalization)("briefcase/dashboard/searchBids"), icon: React.createElement(sok_ui_1.Icon, { className: 'fa-search' }), onChange: function (e) {
                    return type === 'open'
                        ? props.setOpenSearchString(e.target.value)
                        : props.setClosedSearchString(e.target.value);
                } })),
        props.bids.status === 'FETCHING' && (React.createElement("div", { className: "fetching-bids" },
            React.createElement(sok_ui_1.Icon, { className: "fa-spinner fa-spin fa-2x" }))),
        props.bids.status === 'FETCHED' && list.length > 0 ? (React.createElement(sok_ui_1.PanelList, { className: 'bids-list' }, list.slice(0, 6).map(function (bid) { return (React.createElement("li", { key: bid.id },
            React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bid/") +
                    bid.id }, bid.name))); }))) : (props.bids.status === 'FETCHED' &&
            list.length === 0 &&
            (searchString.length === 0 ? (React.createElement("div", { className: 'no-bids-available' },
                React.createElement("div", null,
                    React.createElement("img", { src: avatar })),
                React.createElement("span", { className: 'no-bods-dear' },
                    React.createElement("b", null, (0, translation_1.getLocalization)('pushNotifications/dearSokoproUser'))),
                React.createElement("span", null, (0, translation_1.getLocalization)("briefcase/dashboard/".concat(type === 'open' ? 'thereAreNoOpenBids' : 'thereAreNoEndedBids'))))) : (React.createElement("div", { className: 'no-bids-available' },
                React.createElement("div", null,
                    React.createElement("img", { src: avatar })),
                React.createElement("span", { className: 'no-bids-dear' },
                    React.createElement("b", null, (0, translation_1.getLocalization)('pushNotifications/dearSokoproUser'))),
                React.createElement("span", null, (0, translation_1.getLocalization)('briefcase/dashboard/nobidsWithSearchWord'))))))));
};
exports.default = enhance(function (props) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'content-wrapper-content' },
            React.createElement("div", { className: 'briefcase-view' },
                React.createElement("main", { className: 'content' },
                    React.createElement(sok_ui_1.BreadCrumb, null,
                        React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentBriefcase.project) }, props.currentBriefcase.projectName),
                        React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentBriefcase.project, "/briefcases") }, (0, translation_1.getLocalization)('breadcrumb/sokobid')),
                        React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id) }, props.currentBriefcase.name),
                        React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/dashboard'))),
                    React.createElement(Greeting_1.Greeting, { message: (0, translation_1.getLocalization)('briefcase/dashboard/greeting') }),
                    React.createElement(HeaderButtons, { selectedLanguage: props.selectedLanguage, currentBriefcase: props.currentBriefcase }),
                    React.createElement(sok_ui_1.BoxLayout, { direction: 'column' },
                        React.createElement(sok_ui_1.BoxLayout, { direction: 'row' },
                            React.createElement(sok_ui_1.Panel, { disableCollapse: true, title: (0, translation_1.getLocalization)('briefcase/dashboard/overview') },
                                React.createElement("div", { className: 'overview-content' },
                                    React.createElement("div", { className: 'chart-container' }, props.openBids.length > 0 ||
                                        props.closedBids.length > 0 ||
                                        props.bids.list.length > 0 ? (React.createElement(PieChart_1.PieChart, { width: props.viewportSize === 'MOBILE' ? 380 : 420, height: 240, data: [
                                            {
                                                label: (0, translation_1.getLocalization)('briefcase/dashboard/open'),
                                                value: props.openBids.length,
                                                color: '#6324b0'
                                            },
                                            {
                                                label: (0, translation_1.getLocalization)('briefcase/dashboard/drafts'),
                                                value: props.bids.list.length -
                                                    props.openBids.length -
                                                    props.closedBids.length,
                                                color: '#b698da'
                                            },
                                            {
                                                label: (0, translation_1.getLocalization)('briefcase/dashboard/ended'),
                                                value: props.closedBids.length,
                                                color: '#ded1ee'
                                            }
                                        ] })) : (React.createElement("div", { className: 'no-bids-available' },
                                        React.createElement("span", null, (0, translation_1.getLocalization)('briefcase/dashboard/noData'))))),
                                    React.createElement("div", { className: 'stats-container' },
                                        React.createElement("div", { className: 'stats' },
                                            React.createElement("div", null, props.openBids.length),
                                            React.createElement("div", null, (0, translation_1.getLocalization)('briefcase/dashboard/open'))),
                                        React.createElement("div", { className: 'stats' },
                                            React.createElement("div", null, props.bids.list.length -
                                                props.openBids.length -
                                                props.closedBids.length),
                                            React.createElement("div", null, (0, translation_1.getLocalization)('briefcase/dashboard/drafts'))),
                                        React.createElement("div", { className: 'stats' },
                                            React.createElement("div", null, props.closedBids.length),
                                            React.createElement("div", null, (0, translation_1.getLocalization)('briefcase/dashboard/ended'))))))),
                        React.createElement(sok_ui_1.BoxLayout, { direction: props.viewportSize === 'MOBILE' ? 'column' : 'row' },
                            React.createElement(BidPanel, { type: 'open', props: props }),
                            React.createElement(BidPanel, { type: 'closed', props: props })))))),
        React.createElement(Tools_1.Tools, { currentBriefcase: props.currentBriefcase })));
});
